/**
 * 会员权益
 */
import { trainCampService } from '@/api'
import { AsyncRequest } from '@/utils/request'
const state = {
  list: [],
  heraldList: [],
  JoinTimes: 0,
  userVipCode: null,
  joinData: {
  },

  loading: false,
  finished: false // 是否全部加载完成
}

const getters = {
  list: state => state.list,
  joinData: state => state.joinData,
  JoinTimes: state => state.JoinTimes,
  userVipCode: state => state.userVipCode,
  heraldList: state => state.heraldList,
  finished: state => state.finished,
  loading: state => state.loading
}

const mutations = {
  upgoodsIndexinfo(state, info) {
    state.goodsIndexInfo = info;
  },
  upCamplist(state, { heraldList, defaultList }) {
    state.list = defaultList;
    state.heraldList = heraldList;
  },
  upUserCampinfo(state, { canJoinTimes, userVipCode }) {
    state.JoinTimes = canJoinTimes
    state.userVipCode = userVipCode
  },
  joinSuccess(state, data) {
    state.joinData = data;
  }
}

const actions = {
  // 训练营报名
  trainJoin({ commit }, data) {
    return AsyncRequest({
      loading: false,
      request: () => trainCampService.periodsJoin(data),
      resolve: (res) => {
        console.log('训练营报名--------', res)
      },
      reject: (err) => {
        console.log('err', err)
      }
    })
  },
  // 训练营列表
  periodsList({ commit }, data) {
    return AsyncRequest({
      loading: false,
      request: () => trainCampService.periodsList(data),
      resolve: (res) => {
        if (!res.campTrains) res.campTrains = []
        const { campTrains, canJoinTimes, userVipCode } = res;
        const defaultList = [];
        const heraldList = [];
        campTrains.forEach(item => {
          // callUpStartDate
          const {
            limitSize,
            joinSize,
            callUpStartDate,
            battleEndDate,
            callUpEndDate,
            battleStartDate
          } = item
          item.remainSize = limitSize - joinSize
          if (item.callUpStatus === 3) item.remainSize = 0;
          function dateStr(str, type) {
            if (type) str = str.split(' ')[0]
            return str.replace(/(\d{4})\-(\d{2})\-(\d{2})/, '$2月$3日')
          }
          item.callUpStartDateStr = dateStr(callUpStartDate)
          item.battleEndDateStr = dateStr(battleEndDate, 1)
          item.callUpEndDateStr = dateStr(callUpEndDate, 1)
          item.battleStartDateStr = dateStr(battleStartDate, 1)
          if (isCallUp(item.callUpStartDate)) {
            defaultList.push(item)
          } else {
            heraldList.push(item)
          }
        })
        console.log('训练营列表', defaultList, '预约列表', heraldList)
        commit('upCamplist', { defaultList, heraldList })
        commit('upUserCampinfo', { canJoinTimes: canJoinTimes || 0, userVipCode: userVipCode || null })
      },
      reject: () => {
        commit('upCamplist', { defaultList: [], heraldList: [] })
        commit('upUserCampinfo', { canJoinTimes: 0, userVipCode: null })
      }
    })
  }
}

function isCallUp(date) {
  const dateTime = new Date().getTime();
  const dateStartTime = new Date(date).getTime();
  return (dateStartTime - dateTime) < 0
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
